/* eslint-disable quotes */
import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ value, max = 100, className = '' }) => {
  const percentage = Math.min(Math.max(value, 0), max);

  return (
    <div className={`progress-bar-container ${className}`}>
      <div className="progress-bar-background">
        <div
          className="progress-bar-fill"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="progress-bar-text">{percentage}%</span>
    </div>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number,
  className: PropTypes.string,
};

export default ProgressBar;
